import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {APP_ROLE, SocketService} from '../../shared/services/socket.service';
import {StorageService} from '../../shared/services/storage.service';
import { isNullOrUndefined } from 'util';
import { GameService } from '../../shared/services/game.service';

@Component({
  selector: 'app-remote-creating-game',
  templateUrl: './creating-game.component.html',
  styleUrls: ['./creating-game.component.scss']
})

export class CreatingGameComponent implements OnInit {

  code: String[];
  sessionCode: string;

  connected = false;
  connectionFeedback = 'Wachten op verbinding...';

  constructor(private router: Router, private storageService: StorageService, private socketService: SocketService, private gameService: GameService) {

    this.storageService.getSessionCode().subscribe((sessionCode) => {
      if (!isNullOrUndefined(sessionCode)) {
        this.sessionCode = sessionCode;
      } else {
        if (this.gameService.sessionCode != '') {
          this.sessionCode = this.gameService.sessionCode;
        } else {
          return this.cancelCreatingGame();
        }
      }

      console.log(this.sessionCode);
      this.code = [];
      for (const char of this.sessionCode) {
        this.code.push(char);
      }

      this.initSocketService(this.sessionCode);
    });
  }

  private initSocketService(sessionCode) {
    console.log(sessionCode);
    this.socketService.initSocket(sessionCode, APP_ROLE.REMOTE_ROLE);

    this.socketService.onDigiConnection().subscribe( () => {
      this.connected = true;
      this.connectionFeedback = 'Verbonden met het klasscherm';
    });

    this.socketService.onRemoteConnection().subscribe( () => {

    });
  }

  ngOnInit() {

  }

  cancelCreatingGame() {
    this.socketService.gameStop();
    this.socketService.disconnect();
    this.storageService.clearSessionCode().subscribe(data => {
      console.log('sessionCode cleared local:', data);
      this.router.navigate(['/remote/settings']);
    });
  }

  startGame() {
    this.router.navigate(['/remote/game']);
  }

}



// WEBPACK FOOTER //
// ./src/app/remote/creating-game/creating-game.component.ts